import { ParseIntError, safeParseInt } from './numbers';

export const applyFutureLearnablesOffset = (
  params: Record<string, string | number>,
  offset?: number,
): void => {
  if (offset !== undefined && offset > 0) {
    params.future_learnables_offset = offset;
  }
};

export const parseFutureLearnablesOffset = (
  value: string | string[] | undefined,
): number | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  const parsed = safeParseInt(value);
  if (parsed instanceof ParseIntError || parsed < 0) {
    return undefined;
  }
  return parsed;
};
